const IMIN_EXPERT_IMAGE =
  'https://a.storyblok.com/f/176292/1474x1476/7001b19276/elena-kozyreva.png';

const IMIN_EXPERT_LARGE_IMAGE =
  'https://a.storyblok.com/f/176292/388x586/77b93041f9/elena-kozyreva-full.png';

const PSY_EXPERT_IMAGE =
  'https://a.storyblok.com/f/176292/737x738/cda8c6b880/yulia-malloy.jpeg';

const PSY_EXPERT_LARGE_IMAGE =
  'https://a.storyblok.com/f/176292/1230x1851/c8ad12dd75/yulia-malloy-full.png';

export const meetingExpertDict = {
  en: {
    imin: {
      name: 'Elena Kozyreva',
      description: 'Managing Director for Real Estate projects',
      image: IMIN_EXPERT_IMAGE,
      largeImage: IMIN_EXPERT_LARGE_IMAGE,
    },
    psy: {
      name: 'Yulia Malloy',
      description: 'Investment programs expert',
      image: PSY_EXPERT_IMAGE,
      largeImage: PSY_EXPERT_LARGE_IMAGE,
    },
  },

  ru: {
    imin: {
      name: 'Елена Козырева',
      description: 'Управляющий директор по проектам недвижимости',
      image: IMIN_EXPERT_IMAGE,
      largeImage: IMIN_EXPERT_LARGE_IMAGE,
    },
    psy: {
      name: 'Юлия Маллой',
      description: 'Эксперт инвестиционных программ',
      image: PSY_EXPERT_IMAGE,
      largeImage: PSY_EXPERT_LARGE_IMAGE,
    },
  },
};

export const objectsDeclensions = {
  en: {
    oneObject: 'property',
    twoObjects: 'properties',
    fiveObjects: 'properties',
  },
  ru: { oneObject: 'объект', twoObjects: 'объекта', fiveObjects: 'объектов' },
};

export const realEstateGuideBlockDict = {
  en: {
    title: 'Guides to real estate in Europe: 40+ countries and region overview',
    description:
      'Learn where the highest and lowest residential property prices are, the fastest price growth, and which taxes must be paid when purchasing, owning, and selling property.',
    callToActionTitle: 'Download a summary guide on all European countries',
    callToActionLink: {
      title: 'Download the guide',
      href: '/guides/real-estate-in-europe-guide-en',
    },
    image: '/images/real-estate/real-estate-in-europe-en.png',
    link: {
      title: 'Summary guide on real estate in Europe',
      href: '/guides/real-estate-in-europe-guide-en',
    },
    spoiler: 'Show all countries',
    spoilerClose: 'Show less',
  },
  ru: {
    title:
      'Руководства по недвижимости в Европе: 40+ стран и общее руководство по региону',
    description:
      'Вы узнаете, где самые высокие и низкие цены на жилую недвижимость, самый быстрый рост цен, какие налоги надо платить при покупке, владении и продаже недвижимости.',
    callToActionTitle: 'Скачайте краткое руководство по всем странам Европы',
    callToActionLink: {
      title: 'Скачать руководство',
      href: '/ru/guides/real-estate-in-europe-guide',
    },
    image: '/images/real-estate/real-estate-in-europe-ru.png',
    link: {
      title: 'Краткое руководство по всем странам Европы',
      href: '/ru/guides/real-estate-in-europe-guide',
    },
    spoiler: 'Показать все страны',
    spoilerClose: 'Показать меньше',
  },
};

export * from './constants';
export * from './metadata';

export * from './components/YieldAndManagement';
export * from './components/PropertyOnTheMap';
export * from './components/RealEstateFilterPage';
export * from './components/CountryPropertyList';
export * from './components/Program';
export * from './components/index';
